import { AudienceDataPager } from "@/components/audience-data/AudienceDataPager";
import { paginateRows, qualityIssueLabel, type QualityPageSize } from "@/components/audience-data/audienceDataFormat";
import type { SsdQualityIssue } from "@/lib/ssdSalesClient";

export function AudienceDataQualityIssues(props: {
  issues: SsdQualityIssue[];
  page: number;
  pageSize: QualityPageSize;
  setPage: (n: number) => void;
  setPageSize: (n: QualityPageSize) => void;
}) {
  const paged = paginateRows(props.issues, props.page, props.pageSize);
  if (props.issues.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-zinc-400">No unmatchable rows in this date range.</p>;
  }
  return (
    <div className="min-w-0 space-y-2">
      <AudienceDataPager
        page={paged.page}
        pages={paged.pages}
        pageSize={props.pageSize}
        setPage={props.setPage}
        setPageSize={props.setPageSize}
      />
      <div className="min-w-0 overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500 dark:border-zinc-700 dark:text-zinc-400">
              <th className="py-2 pr-3 font-medium">Sale id</th>
              <th className="py-2 pr-3 font-medium">Date</th>
              <th className="py-2 pr-3 font-medium">Name</th>
              <th className="py-2 pr-3 font-medium">Issue</th>
              <th className="py-2 font-medium">Value</th>
            </tr>
          </thead>
          <tbody>
            {paged.items.map((row) => (
              <tr key={row.id} className="border-b border-gray-100 dark:border-zinc-800">
                <td className="whitespace-nowrap py-1.5 pr-3">{row.source_sale_id || "—"}</td>
                <td className="whitespace-nowrap py-1.5 pr-3">{row.sale_date ?? "—"}</td>
                <td className="py-1.5 pr-3">{row.customer_full_name || row.source_dealer_name || "—"}</td>
                <td className="whitespace-nowrap py-1.5 pr-3">{qualityIssueLabel(row.issue_type)}</td>
                <td className="py-1.5">{row.raw_value || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
